import * as ko from 'knockout';

import index from './index';

export default function () {
  ko.components.register(index.name, index);
}
